import { apiFetch } from "./client";

// API wrapper for all order-related frontend requests
export const orderApi = {

  // Customer checkout (creates a new order from cart)
  checkout: (payload) =>
    apiFetch("/orders/checkout", {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  // Get all orders for the logged-in user
  getOrders: () => apiFetch("/orders"),

  // Get details for a single order
  getOrder: (orderId) => apiFetch(`/orders/${orderId}`),

  // Cancel an existing order
  cancelOrder: (orderId) =>
    apiFetch(`/orders/${orderId}/cancel`, {
      method: "POST",
    }),

  // Update an existing order (only allowed for "saved" orders)
  updateOrder: (orderId, payload) =>
    apiFetch(`/orders/${orderId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),

  // Admin: get all orders in the system
  getAdminOrders: () => apiFetch("/admin/orders"),

  // Admin: get details of a specific order
  getAdminOrder: (orderId) => apiFetch(`/admin/orders/${orderId}`),

  // Admin: update order status (e.g. processing, shipped, delivered)
  updateAdminOrder: (payload) =>
    apiFetch("/admin/orders/status", {
      method: "PUT",
      body: JSON.stringify(payload),
    }),

  // Admin dashboard data (overview stats)
  getDashboard: () => apiFetch("/admin/dashboard"),

  // Admin: get shipment details for a specific order
  getShipment: (orderId) =>
    apiFetch(`/admin/orders/${orderId}/shipment`),

  // Admin: create a shipment for an order
  createShipment: (orderId) =>
    apiFetch(`/admin/orders/${orderId}/shipment`, {
      method: "POST",
    }),

  // Admin: update shipment details (status/address/etc.)
  updateShipment: (orderId, payload) =>
    apiFetch(`/admin/orders/${orderId}/shipment`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),

  // Admin: get staff list
  getStaff: () => apiFetch("/admin/staff"),

  // Customer: get shipment info for their own order
  getOrderShipment: (orderId) =>
    apiFetch(`/orders/${orderId}/shipment`),
};